<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="8">
          <b-card-group>
            <b-card no-body class="p-4">
              <b-card-body>
                  <h1>Mot de passe oublié</h1>
                  <p class="text-muted">Récupération de mot de passe</p>
                  <b-input-group class="mb-3" :class="{hasError: errors.email !== ''}">
                    <b-input-group-prepend>
                      <b-input-group-text>
                        <i class="icon-user"></i>
                      </b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input
                      type="text"
                      class="form-control"
                      name="email"
                      v-model="email"
                      placeholder="Adresse email"
                      autocomplete="username email"
                      v-on:keyup.enter="onEnter"
                    />
                  </b-input-group>
                  <span class="field-error">{{ errors.email }}</span>
                  <b-row>
                    <b-col cols="6">
                      <b-button variant="primary" class="px-4" @click.prevent="resetPwd">Envoyer</b-button>
                    </b-col>
                    <b-col cols="6" class="text-right">
                      <a href="/login">Annuler</a>
                    </b-col>
                  </b-row>
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import {
  isLoggedIn,
  handleLogin,
  handleLogout,
  getBaseUrl,
  getProvider
} from "../../utils/auth";

export default {
  data() {
    return {
      email: "",
      password: "",
      validations: {
        email: {
          text: ""
        },
        password: {
          text: ""
        }
      },
      errors: {
        email: ""
      }
    };
  },
  methods: {
    validateForm() {
      this.clearErrors();
      let validData = true;
      if (this.email.trim() === "") {
        validData = false;
        this.errors.email = "Veuillez entrer un email";
      } else {
        this.errors.email = "";
      }

      return validData;
    },
    resetPwd() {
      if (this.validateForm()) {
        this.$store.commit("IS_LOADING", true);
        let self = this;
        this.$axios.defaults.baseURL = getBaseUrl();
        this.$axios.defaults.headers.common.Accept = "application/json";
        let dataPost = {};
        dataPost.email = this.email;
        dataPost.provider = getProvider();

        this.$axios
          .post("/auth/reset_pwd", dataPost)
          .then(response => {
            this.$store.commit("IS_LOADING", false);
            this.$swal({
              position: "top",
              type: "success",
              title: "Réinitialisation effectuée",
              text: "Un email vient de vous être envoyé",
              showConfirmButton: false,
              timer: 3000
            });
            this.$router.push({ path: "/login" });
          })
          .catch((error) => {
            this.$store.commit("IS_LOADING", false);
            if (error.response && error.response.data && error.response.data.message === 'Unauthorized') {
              this.$swal({
                position: "top",
                type: "error",
                title: "Attention !!",
                text: "L'email indiqué n'existe pas",
                showConfirmButton: false,
                timer: 3000
              });
            } else {
              this.$swal({
                position: "top",
                type: "error",
                title: "Attention !!",
                text: "Une erreur est survenue, si le problème persiste merci de faire un ticket au support",
                showConfirmButton: false,
                timer: 3000
              });
            }
          });
      }
    },
    clearErrors() {
      this.errors.email = "";
    },
    onEnter(event) {
      event.preventDefault();
      event.stopPropagation();
      this.resetPwd();
    }
  }
};
</script>
